module.exports = __webpack_public_path__ + "static/photoalbum-f5bbe038cfea0aa016c43892c8815c6d.jpeg";